export default "__VITE_ASSET__DXfFc7va__"